/**
 * BLOCCO C — lingue vere con URL proprio.
 * Italiano senza prefisso; /en/ /fr/ /es/ hanno URL dedicati indicizzabili.
 * (Tedesco /de/ arriva in una fase successiva — non aggiungerlo qui.)
 * Le altre lingue dello switcher restano solo Google Translate (non indicizzate).
 *
 * NOTA /fr/: il prefisso francese convive con lo short-link legacy
 * "/fr/<slug-frazione>". Regola identica a nginx + backend:
 *   /fr                    → home francese
 *   /fr/<rotta-nota>[/…]   → pagina francese
 *   /fr/<qualsiasi>/…      → pagina francese
 *   /fr/<slug-sconosciuto> → short link frazione (redirect)
 */
export const URL_LANGS = ["en", "fr", "es"];

const URL_LANG_SET = new Set(URL_LANGS);

/** Primi segmenti di rotta pubblica/privata noti (mirror di FR_ROUTE_SEGS in og_share.py). */
const FR_ROUTE_SEGS = new Set([
  "comune", "frazione", "citta", "città", "borgo", "village", "monumento",
  "prodotti", "eventi", "piazze", "piazze-classica", "piazze-immersiva",
  "post", "mondo", "comuni", "monumenti", "campli", "archivio", "archivio-podcast",
  "archivio-eventi", "benvenuto", "come-funziona", "comuni-amici", "manifesto",
  "censisci-luogo", "censisci", "mappa-del-mondo", "mappa-mondo", "mappa-globale",
  "mappa-interattiva", "mappa", "esplora-la-mappa", "eccellenze", "gemellaggi",
  "parchi", "parco", "mare-costa", "terme-benessere", "turismo-nautico",
  "tour-escursioni", "fiere-convegni", "fiere", "spiritualita", "passport",
  "passaporto-unesco", "passaporto-volontariato", "rotta-adriatica",
  "rotta-nautica", "hub-regionale", "rete-abruzzo", "opportunita-1-euro",
  "ecosistema-governance", "cittadinanza-attiva", "radici", "radici-del-progetto",
  "vetrina", "parrocchia", "parrocchie", "porto", "privacy", "termini",
  "cookie-policy", "condizioni-tutela", "dati-societari", "regole-piazza",
  "podcast", "video", "agora", "emergenza", "sentinella-sismica",
  "segnala-bene-comune", "capsule-del-tempo", "creator-pass", "mercato",
  "network-governance", "mayors-council", "missioni-operative", "protocollo",
  "storia-protocollo", "punti-merito", "relazioni-territorio", "universita",
  "ufficio-stampa", "stampa", "pro-loco", "pro-loco-servizio-civile",
  "servizio-civile", "suggerisci-evento", "weekend", "escursioni", "nautica",
  "salute-terme-e-benessere", "sanita", "stabilimenti-balneari",
  "stazione-meteo-emotiva", "aderisci", "adotta", "ambasciatore", "custode", "cosa-fare",
  "qr", "chi-siamo", "contatti", "impronta", "it", "g", "ct",
  "accedi", "login", "registrati", "richiedi-accesso", "account",
  "reset-password", "forgot-password", "profilo", "impostazioni", "messaggi",
  "admin", "dashboard", "dashboard-amministratore", "host", "governance",
  "stanza-governance", "registro-innovazione",
]);

/** "en" | "fr" | "es" | "" — primo segmento se è un prefisso lingua. */
export function pathLang(pathname) {
  const p = String(pathname || "/");
  const seg = p.split("/")[1] || "";
  if (seg === "en" || seg === "es") return seg;
  if (seg !== "fr") return "";
  // /fr o /fr/ → home francese
  const segs = p.split("/").slice(2).filter(Boolean);
  if (!segs.length) return "fr";
  // /fr/<a>/<b>… → francese; /fr/<rotta-nota> → francese; /fr/<slug> → short-link
  if (segs.length > 1 || FR_ROUTE_SEGS.has(segs[0])) return "fr";
  return "";
}

/** Path senza prefisso lingua ("/en/comune/x" → "/comune/x", "/en" → "/"). */
export function stripLangPrefix(pathname) {
  const lang = pathLang(pathname);
  if (!lang) return pathname || "/";
  const rest = String(pathname).slice(lang.length + 1);
  return rest || "/";
}

/** URL della stessa pagina in un'altra lingua (it = senza prefisso). */
export function langUrl(lang, pathname, search = "") {
  const base = stripLangPrefix(pathname);
  const prefixed = URL_LANG_SET.has(lang) ? `/${lang}${base}` : base;
  return `${prefixed}${search || ""}`;
}

/** Path interni che non devono mai ricevere prefisso lingua. */
const NO_PREFIX = /^\/(api|admin|app|embed|mobile|q|uploads|qrcode|wp-|g\/|ct\/|it\/)/;

export function needsLangRedirect(pathname, lang) {
  if (!URL_LANG_SET.has(lang)) return false;
  if (pathLang(pathname)) return false;
  if (NO_PREFIX.test(pathname || "")) return false;
  return true;
}
